import { styled } from 'stitches.config'

export const ExpectRoot = styled('div', {
  width: '100%',
  background: '$tertiary-200',
  marginBottom: '0px !important',
  overflow: 'hidden',

  '@bp3': {
    marginBottom: '-100px !important',
  },

  '@bp4': {
    marginBottom: '-200px !important',
  }
})

export const Container = styled('div', {
  maxWidth: '1920px',
  margin: 'auto',
  textAlign: 'center',
  position: 'relative',
})

export const BackgroundImage = styled('div', {
  width: '100%',
  height: '100%',
  position: 'relative',
})

export const DesktopWrapper = styled('div', {
  display: 'none',
  '@bp2': {
    display: 'block',
  }
})

export const MobileWrapper = styled('div', {
  display: 'block', 
  '@bp2': {
    display: 'none',
  }
})

export const ContentWrapper = styled('div', {
  display: 'none',
  position: 'absolute',
  top: '0px',
  left: '0px',
  right: '0px',
  margin: 'auto',
  zIndex: 1,
  width: '700px',
  paddingTop: '70px',

  '@bp3': {
    display: 'block',
    left: '740px',
    paddingTop: '40px',
    width: '500px',
  },

  '@bp4': {
    left: '1000px',
    paddingTop: '70px',
    width: '700px',
  }

})

export const ExpectText1 = styled('p', {
  position: 'absolute',
  color: '$accent-white',
  fontSize: '$h4',
  textAlign: 'center',
  fontWeight: '$medium',
  width: '270px',
  top: '370px',
  left: '-20px',

  '@bp3': {
    top: '340px',
  },

  '@bp4': {
    top: '450px',
    left: '60px',
  }
})

export const ExpectText2 = styled('p', {
  position: 'absolute',
  color: '$accent-white',
  fontSize: '$h4',
  textAlign: 'center',
  fontWeight: '$medium',
  top: '370px',
  left: '240px',
  width: '270px',

  '@bp3': {
    left: '245px',
    top: '340px'
  },

  '@bp4': {
    top: '450px',
    left: '370px',
  }
})

export const ExpectText3 = styled('p', {
  position: 'absolute',
  color: '$accent-white',
  fontSize: '$h4',
  textAlign: 'center',
  fontWeight: '$medium',
  width: '270px',
  left: '-20px',
  top: '660px',

  '@bp3': {
    top: '624px',
    left: '-15px'
  },

  '@bp4': {
    top: '780px',
    left: '60px',
  }
})

export const ExpectText4 = styled('p', {
  position: 'absolute',
  color: '$accent-white',
  fontSize: '$h4',
  textAlign: 'center',
  fontWeight: '$medium',
  width: '270px',
  top: '660px',
  left: '244px',

  '@bp3': {
    top: '624px'
  },

  '@bp4': {
    top: '780px',
    left: '370px',
  }
})

export const SquareImages = styled('div', {
  position: 'relative'
})

export const SectionTitle = styled('h2', {
  fontSize: '$h2',
  color: '$accent-white',
  fontWeight: '$medium',
  textAlign: 'center',
  margin: 'auto',
  width: '100%',
  maxWidth: '300px',
  paddingBottom: '0px',
  position: 'absolute',
  top: '320px',
  left: '0px',
  right: '0px',

  '@bp2': {
    top: '170px',
    right: '80px',
    left: 'unset',
  },

  '@bp3': {
    fontSize: '$h3',
    position: 'relative',
    margin: 'auto',
    maxWidth: '400px',
    paddingBottom: '10px',
    top: '0px',
    right: '0px',
    left: '0px',
  },

  '@bp4': {
    paddingBottom: '40px',
    fontSize: '$h2',
    maxWidth: '450px',
  }
})

export const MobileContent = styled('div', {
 display: 'block',
  marginTop: '56px',
  marginBottom: '64px',

 '@bp3': {
  display:'none',
 }
})

export const ExpectSquare = styled('div', {
  width: '100%',
  maxWidth: '320px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: 'auto',
  marginBottom: '50px',
})

export const SquareImage = styled('div', {
  width: '100%',
  maxWidth: '340px',
  marginBottom: '12px',
  '& img': {
    borderRadius: '20px'
  }
})

export const ButtonWrapper = styled('div', {
  display: 'none',
  marginTop: '92px',

  '@bp4': {
    marginTop: '108px',
    display: 'block',
  }
})